import {useContext, useState} from 'react'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import {Link} from 'react-router-dom'
import {CouponCodeReportContext} from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const CouponCodeReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const {
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
    isEntityPerformanceChartDataLoading,
    entityPerformanceChartData,
  } = useContext(CouponCodeReportContext)

  return (
    <>
      <tr>
        <td>{row.couponCodeName}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&coupon_code=${row.couponCodeName}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.order}
          </Link>
        </td>
        <td className='text-center'>{row.amount}</td>
        <td className='text-center'>{row.totalCustomerCount}</td>
        <td>{row.contributedDiscountPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.couponCodeName}
          entityName={`Coupon Code Report - ${row.couponCodeName}`}
          onEntityPerformanceChartIdChange={onEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={entityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isEntityPerformanceChartDataLoading}
          entityPerformanceChartData={entityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </>
  )
}

export default CouponCodeReportRow
